import { useTranslation } from "react-i18next";
import Aside from "./Aside";
import DashboardHeader from "./DashboardHeader";
import { useState } from "react";
import Profile from "./Sections/Profile";
import OrphanDonationHistory from "./Sections/OrphanDonationHistory";
import ProjectsDonationHistory from "./Sections/ProjectsDonationHistory";
import GeneralDonationHistory from "./Sections/GeneralDonationHistory";
import OrphanSponsorshipReport from "./Sections/OrphanSponsorshipReport";
import ExternalProjectsReports from "./Sections/ExternalProjectsReports";

const Dashboard = () => {
  const [showMobileAside, setShowMobileAside] = useState(false);
  const [activeSection, setActiveSection] = useState("Profile");
  const { i18n } = useTranslation();
  return (
    <>
      <main
        className={`${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        } flex h-screen`}
      >
        {/* the side bar section  ***************/}
        <Aside
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          setShowMobileAside={setShowMobileAside}
          showMobileAside={showMobileAside}
        />

        {/* the dash board content  *************/}
        <section className="w-full overflow-y-auto">
          {/* the header bar *************/}
          <DashboardHeader
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            setShowMobileAside={setShowMobileAside}
          />

          {/* active section  ************/}
          <div className="w-full px-[20px] py-[10px] md:px-[50px] md:py-[30px]">
            {/* mobile header title  */}
            <p className="md:hidden text-[20px] my-[10px]">
              {" "}
              {activeSection === "Profile"
                ? "My Profile"
                : activeSection === "OrphanDonationHistory"
                ? "Orphan Donation History"
                : activeSection === "ProjectsDonationHistory"
                ? "Projects Donation History"
                : activeSection === "GeneralDonationHistory"
                ? "General Donation History"
                : activeSection === "OrphanSponsorshipReport"
                ? "Orphan Sponsorship Report"
                : activeSection === "ExternalProjectsReports"
                ? "External Projects Reports"
                : ""}
            </p>
            <div className="w-full ">
              {activeSection === "Profile" ? (
                <Profile />
              ) : activeSection === "OrphanDonationHistory" ? (
                <OrphanDonationHistory />
              ) : activeSection === "ProjectsDonationHistory" ? (
                <ProjectsDonationHistory />
              ) : activeSection === "GeneralDonationHistory" ? (
                <GeneralDonationHistory />
              ) : activeSection === "OrphanSponsorshipReport" ? (
                <OrphanSponsorshipReport />
              ) : activeSection === "ExternalProjectsReports" ? (
                <ExternalProjectsReports />
              ) : (
                ""
              )}
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Dashboard;
